module.exports = __webpack_public_path__ + "static/img/3136_phase_function_Paper_PointsHejduk_Prediction.7a5500b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3136_phase_function_Paper_PointsHejduk_Prediction.png
// module id = v1m0
// module chunks = 0